import { render, staticRenderFns } from "./MultiplosSemResultado.vue?vue&type=template&id=24ab78ec&scoped=true&"
import script from "./MultiplosSemResultado.vue?vue&type=script&lang=js&"
export * from "./MultiplosSemResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab78ec",
  null
  
)

export default component.exports